<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/atl56L/tc-custom/9781685500429.jpg?1723407456329" alt="This image is the cover for the book Sugar's Daddy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sugar's Daddy
      </h1>
      <p class="bookDescription body article font2">
        <p>When Cooper’s cat Sugar gets stuck in the tree -- again -- he isn’t sure what to do. He’s afraid of heights, snow has begun to fall, and he isn’t dressed for winter weather. As he pleads with Sugar to come down, a sexy stranger appears out of nowhere to save the day.<br/><br/>Adam is surprised to see a cute guy with no shoes standing out in the snow under a tree, but when the guy starts to drop to the ground, Adam flies into rescue mode and catches him just in time. The weird thing is, once Adam has Cooper in his arms, he’s pretty sure letting him go isn’t going to be easy. Can finding your soulmate happen in an instant?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Hadley Brook
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cf60a2a0